export default __webpack_public_path__ + "static/media/ScreenShot_2.eef409d8.jpg";